import {endpoints} from './endpoints'
import request from '../../request'

export function getSystemModules(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getSystemModules,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getProjects(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getProjects,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function setProjectModules(data, onUploadProgress = null) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.setProjectModules,
			method: 'post',
			data,
			onUploadProgress
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function getJobTypeDefaults(params) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.getJobTypeDefaults,
			method: 'get',
			params
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}

export function updateJobTypeDefaults(data) {
	return new Promise((resolve, reject) => {
		request({
			url: endpoints.updateJobTypeDefaults,
			method: 'post',
			data
		})
			.then(async function (response) {
				resolve(response)
			})
			.catch(function (error) {
				reject(error)
			})
	})
}